export const adminSideBarList = [
    {
        title: 'Kategorije',
        url: '/admin/kategorije',
        logo: '',
    },
    {
        title: 'Podkategorije',
        url: '/admin/podkategorije',
        logo: '',
    },
    {
        title: 'Skup oblasti',
        url: '/admin/skup-oblasti',
        logo: '',
    },
    {
        title: 'Oblasti - knjige',
        url: '/admin/oblast',
        logo: '',
    },
    {
        title: 'Administracija kviz pitanja',
        url: '/admin/kviz-pitanje-management',
        logo: '',
    },
    {
        title: 'Administracija korisnika',
        url: '/admin/usermanagement',
        logo: '',
    },

    {
        title: 'Media library',
        url: '/media',
        logo: '',
    },
];
